'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ajaxfileupload = require('../common/ajaxfileupload');

var _ajaxfileupload2 = _interopRequireDefault(_ajaxfileupload);

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploader = function (_Component) {
	_inherits(FileUploader, _Component);

	function FileUploader() {
		_classCallCheck(this, FileUploader);

		var _this = _possibleConstructorReturn(this, (FileUploader.__proto__ || Object.getPrototypeOf(FileUploader)).call(this));

		_this.afu = new _ajaxfileupload2.default();
		return _this;
	}

	_createClass(FileUploader, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.afu.upload(this.props.files, 'progress' + this.props.time);
		}
	}, {
		key: 'readURL',
		value: function readURL(files, imgId) {
			if (files && files[0]) {
				var reader = new FileReader();

				reader.onload = function (e) {
					document.getElementById(imgId).src = e.target.result;
				};

				reader.readAsDataURL(files[0]);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var preview = { width: '300px' };
			var progress = 'progress';
			var fileUrl = this.props.files;
			var upload = true;

			var deliveryStatusClass = this.props.delivery_status === Constants.MESSAGE_DELIVERY_STATUS_DELIVERED ? "glyphicon glyphicon-ok" : "";
			var lineItemClass = this.props.chatteeId === this.props.senderId ? "left clearfix" : "right clearfix";
			var imageClass = this.props.chatteeId === this.props.senderId ? "chat-img pull-left" : "chat-img pull-right";
			var userDisplayName = this.props.user ? this.props.user.name : "Unknown";

			var imgId = 'fileuploadimage' + this.props.time;
			var progressId = 'progress' + this.props.time;

			var image = '';
			if (upload) {
				this.readURL(this.props.files, imgId);
				image = _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('img', { id: imgId, alt: 'loading...', style: preview }),
					_react2.default.createElement('span', { id: progressId, className: progress })
				);
			} else {
				image = _react2.default.createElement(
					'div',
					{ style: preview },
					_react2.default.createElement('img', { src: fileUrl, alt: 'loading...' })
				);
			}
			return _react2.default.createElement(
				'li',
				{ className: lineItemClass },
				_react2.default.createElement(
					'span',
					{ className: imageClass },
					_react2.default.createElement('img', {
						src: 'http://placehold.it/50/55C1E7/fff&text=U',
						alt: 'User Avatar',
						className: 'img-circle' })
				),
				_react2.default.createElement(
					'div',
					{ className: 'chat-body clearfix' },
					_react2.default.createElement(
						'div',
						{ className: 'header' },
						_react2.default.createElement(
							'strong',
							{ className: 'primary-font' },
							userDisplayName
						),
						_react2.default.createElement(
							'small',
							{ className: 'pull-right text-muted' },
							_react2.default.createElement('span', { className: 'glyphicon glyphicon-time' }),
							(0, _moment2.default)().to(this.props.time),
							_react2.default.createElement('span', { className: deliveryStatusClass })
						)
					),
					image
				)
			);
		}
	}]);

	return FileUploader;
}(_react.Component);

exports.default = FileUploader;


// WEBPACK FOOTER //
// ../chat/lib/components/fileuploader.js